export default {
  namespaced: true,
  state: {
    videoDeviceList: {},
    micDeviceList: {},
    videoDeviceId: {},
    micDeviceId: {}
  },
  getters: {
    videoDeviceList: state => state.videoDeviceList,
    micDeviceList: state => state.micDeviceList,
    videoDeviceId: state => state.videoDeviceId,
    micDeviceId: state => state.micDeviceId
  },
  mutations: {
    setVideoDeviceList(state, videoDeviceList) {
      state.videoDeviceList = videoDeviceList
    },
    setMicDeviceList(state, micDeviceList) {
      state.micDeviceList = micDeviceList
    },
    setVideoDeviceId(state, videoDeviceId) {
      state.videoDeviceId = videoDeviceId
    },
    setMicDeviceId(state, micDeviceId) {
      state.micDeviceId = micDeviceId
    }
  }
}
